import { render, staticRenderFns } from "./AfterSalesInfo.vue?vue&type=template&id=bca4d56a&"
import script from "./AfterSalesInfo.vue?vue&type=script&lang=js&"
export * from "./AfterSalesInfo.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports